<template>
    <div class="toast" v-show="isShow">
        <i :class="['icon', type ? type : '']" v-if="type"></i>
        <i class="txt">{{ message }}</i>
    </div>
</template>

<script>
export default {
    name: 'Toast',
    data() {
        return {
            message: '',
            type: '',
            isShow: false
        }
    },
    methods: {
        show(message, time = 2000, fn, type) {
            this.isShow = true
            this.message = message
            this.type = type
            setTimeout(() => {
                this.isShow = false
                this.message = ''
                if (Object.prototype.toString.call(fn) === '[object Function]') {
                    fn()
                }
            }, time)
        }
    }
}
</script>

<style lang="less" scoped>
.toast {
    background: #292929;
    font-size: 14px;
    border-radius: 20px;
    height: 40px;
    position: fixed;
    text-align: center;
    line-height: 40px;
    padding: 0 30px;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    transition: all 3s;
    z-index: 99999;

    i {
        vertical-align: middle;
        font-style: normal;
    }

    .txt {
        color: rgba(255, 255, 255, 1);
        user-select: none;
    }

    .icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 16px;
    }
}
</style>
